import React from "react";
import { Container, Row, Col } from "shards-react";

//import PageTitle from "../components/common/PageTitle";
import ProjectStructureDetail from "../components/project-structure/ProjectStructureDetail";

class ProjectStructure extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  
  render() {
    return (
      <Container fluid className="main-content-container px-4">
        {/* <Row noGutters className="page-header py-4">
          <PageTitle title="" subtitle="" md="12" className="ml-sm-auto mr-sm-auto" />
        </Row> */}
        <Row className="py-3">
          <Col lg="12">
            <ProjectStructureDetail projectId={this.props.match.params.id} projectStructureId={this.props.match.params.sid} />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default ProjectStructure;
